import { HIDE_DURING_DOWNTIME } from 'constants/featureFlag';

import { useFlagIsActivated } from 'hooks/featureFlag';

// During pre-downtime we allow users to visit the share page,
// but during this time there is limited functionality availible
// due to restricted routes. We hide a bunch of UI related
// to make the experience a bit less buggy
/**
 * @typedef {{children: any, replaceWith?: any}} DowntimeProps
 * @param {DowntimeProps} param0
 */
const HideDuringDowntime = ({ children, replaceWith }) => {
  const shouldHideComponent = useFlagIsActivated({
    flag: HIDE_DURING_DOWNTIME,
    activationValues: [true],
  });

  if (shouldHideComponent) {
    if (replaceWith) {
      return replaceWith;
    }

    return null;
  }

  return children;
};

export default HideDuringDowntime;
